import { idZodSchema } from "@@/shared/id";
import type { Except } from "type-fest";
import { z } from "zod";

type RemoveStoredPaymentMethodCommand = {
    readonly _type: "REMOVED_STORED_PAYMENT_METHOD_COMMAND";
    readonly storedPaymentMethodId: string;
    readonly externalId: string;
};

const removeStoredPaymentMethodCommandZodSchema: z.ZodSchema<RemoveStoredPaymentMethodCommand> =
    z.object({
        _type: z.literal("REMOVED_STORED_PAYMENT_METHOD_COMMAND"),
        storedPaymentMethodId: idZodSchema,
        externalId: z.string(),
    });

const createRemoveStoredPaymentMethodCommand = (
    params: Except<RemoveStoredPaymentMethodCommand, "_type">,
): RemoveStoredPaymentMethodCommand => {
    return {
        ...params,
        _type: "REMOVED_STORED_PAYMENT_METHOD_COMMAND",
    };
};

export {
    createRemoveStoredPaymentMethodCommand,
    removeStoredPaymentMethodCommandZodSchema,
};
export type { RemoveStoredPaymentMethodCommand };
